import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_hrmradn4yd: FaireBrandEntity = {
  token: "b_hrmradn4yd",
  type: "brand",
  name: "EmberLoom",
  avatarUrl:
    "https://cdn.faire.com/fastly/87aa9e4fbeac83ab4b2fb6ecfe00870635c4c5841a469d447f4affebbec0a6bd.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/43a576c6f5d7c69790d11882a7451625e79c28ffcfd577f86ee38cb6319882b3.png",
  logoUrl:
    "https://cdn.faire.com/fastly/87aa9e4fbeac83ab4b2fb6ecfe00870635c4c5841a469d447f4affebbec0a6bd.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/43a576c6f5d7c69790d11882a7451625e79c28ffcfd577f86ee38cb6319882b3.png",
  location: "Rowland Heights, CA, USA",
  minimumOrderDollars: 139,
  rating: 4.5,
  reviewCount: 115,
  isInsider: true,
  description: "Custom Design by Mrwolf",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:03.201Z",
    importedBy: "entity-db-cli",
  },
};
